import { render, staticRenderFns } from "./consult.vue?vue&type=template&id=746f3874&scoped=true"
import script from "./consult.vue?vue&type=script&lang=js"
export * from "./consult.vue?vue&type=script&lang=js"
import style0 from "./consult.vue?vue&type=style&index=0&id=746f3874&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746f3874",
  null
  
)

export default component.exports